// extracted by mini-css-extract-plugin
module.exports = {"centered":"styles_centered__FxgUd","darken":"styles_darken__2ZnXo","feedBackIcon":"styles_feedBackIcon__22n_A","video":"styles_video__30kam"};